import React, { useEffect, useState } from "react";
import { IoMdSend } from "react-icons/io";
import LoadingPage from "../Loading/loading";
import { getUserTeam, getUsersInvitation } from "../../api/brokers";
import { Cookies } from "react-cookie";
import "./inv.css";

const InvitationComponent = () => {
  const cookie = new Cookies();

  const [searchTerm, setSearchTerm] = useState("");
  const [users, setUsers] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState(null);

  const [selectedBroker, setSelectedBroker] = useState(null);

  const fetchUsers = () => {
    getUserTeam().then((result) => {
      setUsers(result.data.users);
      setFilteredUsers(result.data.users);
    });
  };

  // initial load
  useEffect(() => {
    fetchUsers();
  }, []);

  // search logic
  useEffect(() => {
    if (!users) return;

    const timeout = setTimeout(() => {
      const term = searchTerm.toLowerCase().trim();

      if (!term) {
        setFilteredUsers(users);
        return;
      }

      const result = users.filter((broker) => {
        const name = broker.inviterName?.toLowerCase() || "";
        const phone = broker.inviterPhone?.toString() || "";

        return name.startsWith(term) || phone.startsWith(term);
      });

      setFilteredUsers(result);
    }, 300);

    return () => clearTimeout(timeout);
  }, [searchTerm, users]);

  // disable scroll when modal open
  useEffect(() => {
    document.body.style.overflow = selectedBroker ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedBroker]);

  if (users === null) return <LoadingPage />;

  return (
    <>
      <div>
        {/* Search */}
        <div className="search-container">
          <div className="search-input-wrapper">
            <input
              type="text"
              placeholder="Name or Phone number"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
        </div>

        <div>Number of Brokers is {filteredUsers?.length}</div>

        {/* List */}
        <div className="card-cards">
          {filteredUsers?.length === 0 ? (
            <div>Not found brokers</div>
          ) : (
            filteredUsers?.map((broker) => (
              <div key={broker._id} className={`card-card`}>
                <div className="card-info" style={{}}>
                  <div>
                    <p className="line">
                      <span className="label">Name:</span> {broker.inviterName}
                    </p>
                    <p className="line">
                      <span className="label">Phone:</span>{" "}
                      {broker.inviterPhone}
                    </p>
                    <p className="line">
                      <span className="label">Team No:</span>{" "}
                      {broker.invitedCount}
                    </p>
                  </div>
                </div>
                <button
                  onClick={() => setSelectedBroker(broker)}
                  className="action-btn ban-btn"
                >
                  View team
                </button>
              </div>
            ))
          )}
        </div>

        {/* Modal */}
        {selectedBroker && (
          <div
            className="modal-overlay"
            onClick={() => setSelectedBroker(null)}
          >
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <h2>Team Members</h2>

              <table className="team-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone</th>
                  </tr>
                </thead>

                <tbody>
                  {(selectedBroker.invitedUsers || []).map((member, index) => (
                    <tr key={index}>
                      <td>{member.name}</td>
                      <td>{member.phone}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <button onClick={() => setSelectedBroker(null)}>Close</button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default InvitationComponent;
